import { DeleteOutlined, EventNoteOutlined } from '@mui/icons-material';
import {
  Alert,
  Box,
  Chip,
  Container,
  Snackbar,
  Stack,
  Typography,
} from '@mui/material';
import { deleteDoc, doc } from 'firebase/firestore';
import { useCallback, useMemo, useState } from 'react';
// @ts-ignore
import MicrospecDataTable from '../../../MicrospecDynamicUI/Components/DataTable/MicrospecFirestoreDataTable';
import { useMicrospecDynamicUIContext } from '../../../MicrospecDynamicUI/GlobalProvider';
import AppointmentDialog from './AppointmentDialog';

const ManageClients = () => {
  const { cloudProvider } = useMicrospecDynamicUIContext();
  const userProfile = (cloudProvider as any).userProfile?.attributes;
  const firestore = (cloudProvider as any).firestore;
  const [refreshKey, setRefreshKey] = useState(0);

  // Appointment dialog state
  const [apptDialogOpen, setApptDialogOpen] = useState(false);
  const [apptClient, setApptClient] = useState<any>(null);

  // Snackbar
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackMessage, setSnackMessage] = useState('');

  const handleDelete = useCallback(async (row: any) => {
    try {
      await deleteDoc(doc(firestore.instance, 'clients', row.id));
      setRefreshKey((k) => k + 1);
    } catch (e) {
      console.error('Error deleting client', e);
    }
  }, [firestore?.instance]);

  const handleOpenApptDialog = useCallback((row: any) => {
    setApptClient(row);
    setApptDialogOpen(true);
  }, []);

  const handleApptSuccess = useCallback((message: string) => {
    setSnackMessage(message);
    setSnackOpen(true);
  }, []);

  const columns = useMemo(() => [
    {
      field: 'first_name',
      headerName: 'الاسم الأول',
      width: '20%',
    },
    {
      field: 'last_name',
      headerName: 'اسم العائلة',
      width: '20%',
    },
    {
      field: 'contacts',
      headerName: 'وسائل التواصل',
      width: '40%',
      render: (value: any) => (
        <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
          {(value || []).map((c: any, i: number) => (
            <Chip
              key={i}
              size="small"
              label={c.value}
              color={c.type === 'phone' ? 'primary' : 'default'}
              variant="outlined"
            />
          ))}
        </Stack>
      ),
    },
    {
      field: 'created_at',
      headerName: 'تاريخ الإضافة',
      width: '20%',
      render: (value: any) => {
        if (!value) return '-';
        const date = new Date(value?.seconds ? value.seconds * 1000 : value);
        return (
          <Typography variant="caption">
            {date.toLocaleDateString('ar')}
          </Typography>
        );
      },
    },
  ], []);

  const actions = useMemo(() => [
    {
      icon: <EventNoteOutlined fontSize="small" />,
      label: 'تحديد موعد',
      onClick: handleOpenApptDialog,
    },
    {
      icon: <DeleteOutlined fontSize="small" />,
      label: 'حذف',
      onClick: handleDelete,
    },
  ], [handleDelete, handleOpenApptDialog]);

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" fontWeight={700}>عملائي</Typography>
        <Typography variant="body2" color="text.secondary">
          إدارة العملاء الذين تم إضافتهم من الرسائل
        </Typography>
      </Box>
      {/* @ts-ignore */}
      <MicrospecDataTable
        key={refreshKey}
        collection="clients"
        title={{ type: 'Literal', text: 'العملاء' } as any}
        subtitle={{ type: 'Literal', text: 'قائمة العملاء' } as any}
        columns={columns as any}
        actions={actions as any}
        wheres={userProfile?.uid ? [{ field: 'owner_id', value: userProfile.uid }] : []}
        searchable
        refreshable
        pageSize={10}
      />

      <AppointmentDialog
        open={apptDialogOpen}
        onClose={() => setApptDialogOpen(false)}
        onSuccess={handleApptSuccess}
        fixedClient={apptClient}
      />

      <Snackbar
        open={snackOpen}
        autoHideDuration={2000}
        onClose={() => setSnackOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity="success" variant="filled">{snackMessage}</Alert>
      </Snackbar>
    </Container>
  );
};

export default ManageClients;
